var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8652 26.875L20.884 20.8937M13.1152 9V17.25M8.99023 13.125H17.2402M24.1152 13.125C24.1152 19.2001 19.1904 24.125 13.1152 24.125C7.0401 24.125 2.11523 19.2001 2.11523 13.125C2.11523 7.04987 7.0401 2.125 13.1152 2.125C19.1904 2.125 24.1152 7.04987 24.1152 13.125Z",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlus);
export default __webpack_public_path__ + "static/media/search-plus.744c242705713fb29c696514f1eccf58.svg";
export { ForwardRef as ReactComponent };